import ReferRoutes from "../pages/Refer/Refer.routes";
import { isMfaEnforced, showVerificationPage } from "../utils";

// by default all the guest routes are filtered
export const generateRoutesFromConfigs = (configs, auth = "guest", properties) => {
    let routes = [];
    configs.forEach(config => {
        if (isMfaEnforced() && !config.mfaNotRequired) {
            return; // Skip this config if MFA is enforced and the route requires MFA
        }

        if (config?.kyc) {
            if (!showVerificationPage(properties.user)) {
                return false;
            }
        }
        if(config.name === ReferRoutes.name && !properties?.referal?.isEnabled) {
            return;
        }
        if (config.auth.find(ele => ele === auth)) {
            if (config.bank) {
                if (properties.bankEnabled) {
                    routes = [...routes, ...config.routes]
                }
            } else {
                routes = [...routes, ...config.routes]
            }
        }
    });

    return routes;
}